import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY

export const getUnitsReport = (setUnitsReport, dateFilters) => {
    const startDate = dateFilters.start.value.toISOString().split('T')[0];
    const endDate = dateFilters.end.value.toISOString().split('T')[0];

    api.get(urlApi + `/unitReport/getUnitsReports/?fecha_inicio=${startDate}&fecha_fin=${endDate}`).then((res) => {
        setUnitsReport(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}